<template>
	<el-dialog :visible.sync="visible" :title="title" width="540px" :close-on-click-modal="false" :destroy-on-close="true" :before-close="handCloce">
		<p class="pt-16 pb-30 ml-10" v-if="isBatch">
			共选中
			<span class="yx-color-primary">{{ total }}</span>
			个{{ tagTypeName }}
			<span v-if="count">
				，其中
				<span class="yx-color-primary">{{ count }}个</span>
				{{ tagTypeName }}的标签数量已达上限，无法添加新标签。
			</span>
		</p>
		<el-form :model="form" ref="form" label-width="70px" class="ml-10">
			<el-form-item :label="`${tagTypeName}标签`">
				<select-tag
					ref="selectTag"
					:type="type"
					style="width: 100%"
					:selectValue="selectValue"
					:arr="list"
					:multiple="!isBatch"
					v-model="form.tags_id"
				></select-tag>
			</el-form-item>
		</el-form>
		<div class="footer-dialog flex-row-align-center flex-just-between" slot="footer">
			<div>
				<div v-if="showAddTag" class="color-gy-7 fz-12">
					没有想要的标签？你可以
					<span class="yx-color-primary cursor-pointer" @click="handleGoTagManage">新建标签</span>
				</div>
			</div>
			<div>
				<el-button @click="handCloce">取 消</el-button>
				<el-button el-button type="primary" @click="submit" :disabled="isDisabled">确 认</el-button>
			</div>
		</div>
		<AddTag ref="addTag" @refresh="handleAddTag" />
	</el-dialog>
</template>
<script>
import selectTag from './selectTag.vue';
import { setProductTag, setProductTags } from '@/api/shopManage';
import { setAnchorTag, setAnchorTags } from '@/api/talentCRM';
import { batchTagging } from '@/api/contentLibray.js';
import AddTag from './addTag';
export default {
	components: {
		selectTag,
		AddTag,
	},
	props: {
		// 0商品标签 1达人标签 2素材标签
		type: {
			type: [Number, String],
			default: '0',
		},
		showAddTag: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		total() {
			return this.list.length || 0;
		},
		count() {
			return this.list.filter(item => item.tagList?.length > 9).length || 0;
		},
		ids({ type }) {
			let key = {
				0: 'product_id',
				1: 'anchor_id',
			};
			return this.list.map(item => item[key[type]])?.join(',');
		},
		material_ids() {
			return this.list.map(item => item.materialId || item.id);
		},
		isBatch() {
			return this.list.length > 1 ? true : false;
		},
		isDisabled() {
			return !((this.selectValue && this.selectValue.length) || this.form.tags_id);
		},
		tagTypeName({ type }) {
			let obj = {
				0: '商品',
				1: '达人',
				2: '素材',
			};
			return obj[type];
		},
	},
	data() {
		return {
			visible: false,
			title: '',
			form: {
				tags_id: '',
			},
			list: [],
			selectValue: [],
		};
	},
	methods: {
		handleGoTagManage() {
			this.$refs['addTag'].show();
		},
		show(title, list) {
			this.list = list;
			this.title = title;
			if (!this.isBatch) {
				if ([0, 1].includes(+this.type)) {
					this.selectValue = this.list[0].tag_arr?.map(item => item.tag_name);
				}
				if ([2].includes(+this.type)) {
					this.selectValue = this.list[0].tagList?.map(item => item.tagName);
				}
			}
			this.visible = true;
		},
		async submit() {
			const {
				form: { tags_id },
				ids,
				isBatch,
				type,
				tagTypeName,
				material_ids,
			} = this;
			let tags_ids = tags_id;
			let api = {
				0: isBatch ? setProductTag : setProductTags,
				1: isBatch ? setAnchorTag : setAnchorTags,
				2: isBatch ? batchTagging : batchTagging,
			};
			let params = {
				0: isBatch ? { tags_id, product_ids: ids } : { tags_ids, product_id: ids },
				1: isBatch ? { tag_id: tags_id, anchor_ids: ids } : { anchor_id: ids, tag_ids: tags_id },
				2: isBatch ? { ids: material_ids, tagIds: tags_ids.split(','), addFlag: true } : { ids: material_ids, tagIds: tags_ids.split(',') },
			};
			await api[type](params[type]);
			this.$message.success(`修改${tagTypeName}标签成功`);
			this.$emit('refreshList', tags_ids);
			this.handCloce();
		},
		handCloce() {
			this.form = {
				tags_id: '',
			};
			this.selectValue = [];
			this.$refs.selectTag.value = '';
			this.visible = false;
		},
		handleAddTag() {
			this.$refs['selectTag'].resetPage();
			// this.$refs['selectTag'].reset();
			this.$refs['selectTag'].getList();
		},
	},
};
</script>
<style lang="less" scoped></style>
